import React from 'react';
import './Messages.css';
import EmptyPane from '../../components/ChatLayout/EmptyPane';

// The rail and conversation list come from ChatShell; this route contributes
// only the placeholder pane shown before a chat is picked.
const Messages = () => <EmptyPane />;

export default Messages;
